export const PACKAGES_OVERVIEW_REQUEST = "PACKAGES_OVERVIEW_REQUEST";
export const PACKAGES_OVERVIEW_RESULT = "PACKAGES_OVERVIEW_RESULT";